var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tableSonTemp"},[(_vm.data || _vm.data === 0)?_c('div',{staticClass:"ellipsisStyle",style:({
      color: _vm.color ? _vm.color : '#606266',
    }),attrs:{"title":_vm.data}},[_vm._v(" "+_vm._s(_vm.data)+" ")]):_c('div',[_vm._v("-")])])
}
var staticRenderFns = []

export { render, staticRenderFns }